"use strict";

const SamplingSiteFilters = function () {
  const searchDbFields = ["site_identifier", "address"];
  const searchFields = ["siteIdentifier", "address"];

  var filterResourceDataHandler = async function (
    unfilteredData,
    filters,
    loadingScreen,
    smartFilters,
  ) {
    if (onlineFilterIsSet(filters)) {
      try {
        return await ResourceFilters.filterOnline(
          unfilteredData,
          loadingScreen,
          SamplingSiteGeoServerLayer.getLayerData,
        );
      } catch (e) {
        ApiError.assertIs(e);
      }
    }

    return filterOffline(unfilteredData, filters, smartFilters);
  };

  var filterOffline = function (unfilteredData, filters, smartFilters) {
    return smartFilters ? smartFilters.filter(unfilteredData, filters) : unfilteredData;
  };

  var onlineFilterIsSet = function (filters) {
    if (filters.toDoFilters) {
      return ResourceFilters.toDoSpatialFiltersAreSet(filters.toDoFilters);
    } else {
      return ResourceFilters.spatialFiltersAreSet(filters) || isOnlineDateFilterSet(filters);
    }
  };

  var addGeoServerViewParams = function (params, filters) {};

  var isOnlineDateFilterSet = function (filters) {
    return isOnlineDateType(filters.dateType) && (filters.dateFrom || filters.dateTo);
  };

  var isOnlineDateType = function (dateType) {
    return ["routine", "repair", "clean"].includes(dateType);
  };

  var addGeoServerFilterQuery = function (queryStrings, filters) {
    if (filters.searchString) {
      queryStrings.push(
        GeoServerFilterFunctions.getSearchQuery(searchDbFields, filters.searchString),
      );
    }
    GeoServerFilterFunctions.addGeographicalFocusFiltersToQuery(filters, queryStrings);
  };

  var getFilterConfigs = function () {
    return {
      maintainedBy: "maintainedBy",
      sitePhase: "sitePhase",
      siteType: "siteType",
      subGroups: "groupId",
      drainsToRw: "drains_to_rw",
      drainsToC: "drains_to_c",
      catchmentName: "catchment_name",
      zones: "zone_names",
      otherFilters: (datum, filters) => {
        return ResourceFilters.passSearchStringFilter(datum, filters, searchFields);
      },
    };
  };

  return {
    filterResourceDataHandler,
    isOnlineDateFilterSet,
    addGeoServerFilterQuery,
    addGeoServerViewParams,
    getFilterConfigs,
  };
};

module.exports = SamplingSiteFilters();

const ApiError = require("../errors/apiError");
const ResourceFilters = require("../filters/resourceFilters");
const GeoServerFilterFunctions = require("../mapFunctions/geoServerFilterFunctions");
const SamplingSiteGeoServerLayer = require("./samplingSiteGeoServerLayer");
